import React from 'react';
import s from './TableElements.module.css';
import {transactionStatusTranslate} from '../../../assets/utils/translatersFunc';
import {Transaction} from '../../../types/TypesUserAccounts';
import TransactionsActions from '../../../PersonalOffice/Transactions/components/TransactionsActions';
type Props = {
	transaction: Transaction;
};
const TableElement: React.FC<Props> = ({transaction}) => {
	return (
		<div className={s.elementContainer}>
			<div className={s.elementItem}>{transaction.transaction_id}</div>
			<div className={s.elementItem}>{transaction.account_from}</div>
			<div className={s.elementItem}>{transaction.money_from}</div>
			<div className={s.elementItem}>{transaction.account_to}</div>
			<div className={s.elementItem}>{transaction.money_to}</div>
			<div className={s.elementItem}>
				{transactionStatusTranslate(transaction.status)}
			</div>
			<div className={s.elementItem}>
				<TransactionsActions transaction={transaction} />
			</div>
		</div>
	);
};

export default TableElement;
